export default __webpack_public_path__ + "static/media/4_example.016f0a6e.jpg";